import React from 'react';
import './styles.scss';

const Loader = () => {
  return (
    <div className="loader-ctrl">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
